import { selectCalendarAccounts } from '../CalendarAccounts';
import { selectDroppedStickers } from '../DroppedStickers';
import { getSkins, selectSkins } from '../Products';
import { getUserLists } from '../UserLists';
import { selectUserLists } from '../UserLists/selectors';
import { userOptions as selectUserOptions } from '../UserOptions/selectors';
import { updateOnboardingStep, setStreamsReady } from './actions';

export const initializeOnboardingAfterFetch = () => (dispatch, getState) => {
  const checkAndInitialize = () => {
    const state = getState();
    const { CalendarAccounts, Products, DroppedStickers, UserLists, UserOptions } = state;

    const skinsFetched = !Products.isFetching && Products.SKINS.length > 0;
    const calendarAccountsFetched =
      CalendarAccounts.isFetched && !CalendarAccounts.isFetching && CalendarAccounts.data;
    const droppedStickersFetched = !DroppedStickers.isFetching && DroppedStickers.data;
    const userListsFetched = !UserLists.lists.isFetching && UserLists.lists.fetched;
    const userOptionsFetched = !UserOptions.isFetching && UserOptions.fetched && UserOptions.data;

    const allDataFetched =
      skinsFetched &&
      calendarAccountsFetched &&
      droppedStickersFetched &&
      userListsFetched &&
      userOptionsFetched;

    if (Products.SKINS.length === 0 && !Products.isFetching) {
      dispatch(getSkins());
      setTimeout(checkAndInitialize, 1000);
    } else if (!userListsFetched) {
      dispatch(getUserLists());
      setTimeout(checkAndInitialize, 1000);
    } else if (allDataFetched) {
      dispatch(initializeOnboarding());
    } else {
      // Retry after a delay
      setTimeout(checkAndInitialize, 1000);
    }
  };
  checkAndInitialize();
};

export const initializeOnboarding = () => (dispatch, getState) => {
  const state = getState();
  const userOptions = selectUserOptions(state);

  //Check if the user's cover matches the default cover
  const covers = selectSkins(state);
  const defaultCover = covers.find(cover => cover.product.isFree);
  const hasSelectedCover = userOptions.skin_id !== defaultCover.id;
  dispatch(updateOnboardingStep('chooseCover', hasSelectedCover));

  //Check if user has selected a handwriting font
  const hasSelectedFont = userOptions.font;
  dispatch(updateOnboardingStep('selectHandwritingFont', hasSelectedFont));

  //Check if user has created a list
  const userLists = selectUserLists(state);
  const hasList = userLists.length > 0;
  dispatch(updateOnboardingStep('createList', hasList));

  //Check if user has a dropped sticker
  const droppedStickers = selectDroppedStickers(state);
  const hasDroppedSticker = Object.values(droppedStickers).some(
    stickersArray => Array.isArray(stickersArray) && stickersArray.length > 0
  );
  dispatch(updateOnboardingStep('placeSticker', hasDroppedSticker));

  // Check if any calendar is active and not hidden
  const calendarAccounts = selectCalendarAccounts(state);
  const hasConnectedCalendar = calendarAccounts.some(account =>
    account.calendars.some(calendar => calendar.active && !calendar.hidden)
  );
  dispatch(updateOnboardingStep('connectCalendar', hasConnectedCalendar));

  dispatch(setStreamsReady(true));
};
